<template>
    <div class="tsa-progress" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <el-progress type="circle" :percentage="percentage"></el-progress>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            show: false,
            percentage: 0,
        }
    },
    watch: {
        show (val) {
            if (!val) {
                this.percentage = 0
            }
        }
    },
    methods: {
        update (val) {
            this.percentage = val
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-progress {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
        }
        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            /deep/.el-progress {
                .el-progress__text {
                    color: #ffffff;
                }
            }
        }
    }
</style>